import { HabitLogModel } from "../habit-log-model";

export class HabitReportModel {
    public CalenderDate:Date;
    public HabitLogModel:HabitLogModel[];
}
